import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const DashboardInspectRequest = (dashboardId, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Dashboard/Inspect`,
	params: { dashboardId, userId }
});
